import { createContext, useContext } from 'react';

import { ActiveOTTContextValue } from './active-ott-constants';

export const ActiveOTTContext = createContext<ActiveOTTContextValue | null>(null);

export const useActiveOTTContext = (): ActiveOTTContextValue => {
  const context = useContext(ActiveOTTContext);
  if (!context) {
    throw new Error('useActiveOTTContext must be used within an ActiveOTTContext.Provider');
  }
  return context;
};
